import { ExtraCategoryFormFields } from "../../extrasCategories/presentation/types/ExtraCategoryFormTypes";
import { Image } from "../../shared/widgets/ImageManager";
import {
  ExtraApplyTo,
  ExtraLockType,
  ExtraRateType,
  ExtraRestrictionUse,
  ExtraType,
  ExtraUse,
  RangeDateWindowType,
  TranslationType,
  GuestType,
} from "../types";

export interface CustomExtra extends ExtraCategoryFormFields {
  id: string;
  ticker: string;
  active: boolean;
  visible: boolean;
  inventoryLinesList: string[];
  chainInventoryLinesList: string[][];
  codesList: string[];
  emailsList: string[];
  translationsList: TranslationType[];
  multimediaList: Image[];
  rateType: ExtraRateType;
  ratePrice: number;
  type: ExtraType;
  availability: ExtraUse;
  applyTo: ExtraApplyTo;
  applyToGuests: GuestType[];
  maxUnits?: string;
  lockType: ExtraLockType;
  blockage: ExtraUse;
  travelWindow: RangeDateWindowType;
  minStayType: ExtraRestrictionUse;
  minStay?: number;
  maxStayType: ExtraRestrictionUse;
  maxStay?: number;
  minNoticeType: ExtraRestrictionUse;
  minNotice?: number;
  maxNoticeType: ExtraRestrictionUse;
  maxNotice?: number;
  isShared?: boolean;
  parentPropertyTicker?: string;
  tax: boolean;
}

export enum CRUD_MODE {
  EDIT,
  ADD,
  DUPLICATE,
}

export interface FormType extends ExtraCategoryFormFields {
  id: string;
  ticker: string;
  active: boolean;
  visible: boolean;
  codesList: string;
  emailsList: string;
  inventoryLinesList: string[];
  chainInventoryLinesList: string[][];
  translationsList: TranslationType[];
  rateType: ExtraRateType;
  ratePrice: number;
  type: ExtraType;
  availability: ExtraUse;
  applyTo: ExtraApplyTo;
  applyToGuests: GuestType[];
  maxUnits?: string;
  lockType: ExtraLockType;
  blockage: ExtraUse;
  travelWindow: RangeDateWindowType;
  minStayType: ExtraRestrictionUse;
  minStay?: number;
  maxStayType: ExtraRestrictionUse;
  maxStay?: number;
  minNoticeType: ExtraRestrictionUse;
  minNotice?: number;
  maxNoticeType: ExtraRestrictionUse;
  maxNotice?: number;
  tax: boolean;
}

export interface SmartInventoryListType {
  field?: string;
  value: string[][];
}

export enum ExtraModalActionType {
  SUCCESS_CREATE,
  ERROR_CREATE,
  SUCCESS_UPDATE,
  ERROR_UPDATE,
  ERROR_GET_ONE,
  ERROR_GET_INVENTORY_LINES_EXCEL,
  ERROR_PROCESS_INVENTORY_LINES_EXCEL,
  ERROR_LOAD_PROPERTY_INVENTORY,
  ERROR_DOWNLOAD_ONE_TIME_PROMO_CODE_EXCEL,
  SUCCESS_PROCESS_ONE_TIME_PROMO_CODE_EXCEL,
  ERROR_PROCESS_ONE_TIME_PROMO_CODE_EXCEL,
}

export interface ExtraModalAction {
  type: ExtraModalActionType;
  data?: Record<string, number>;
}
